module.exports = __webpack_public_path__ + "img/back-to-login.8562f87b.svg";